import birds from "./birds.png";
import book from "./book.png";
import bottomleft from "./bottomleft.png";
import bottomlefteyes from "./bottomlefteyes.png";
import bottomright from "./bottomright.png";
import bottomrighteyes from "./bottomrighteyes.png";
import butterfly from "./butterfly.png";
import candle from "./candle.png";
import cloud from "./cloud.png";
import curtain from "./curtain.png";
import desk from "./desk.png";
import emily from "./emily.png";
import emilycollage from "./emilycollage.png";
import envelope from "./envelope.png";
import flowers from "./flowers.png";
import flowerscollage from "./flowerscollage.png";
import greenbg from "./greenbg.png";
import nophone from "./nophone.webp";
import paper from "./paper.png";
import quill from "./quill.webp";
import shelf from "./shelf.png";
import sticker from "./sticker.png";
import sun from "./sun.png";
import topleft from "./topleft.png";
import toplefteyes from "./toplefteyes.png";
import topright from "./topright.png";
import toprighteyes from "./toprighteyes.png";
import vine from "./vine.png";
import volumeoff from "./volumeoff.svg";
import volumeon from "./volumeon.svg";
import wallpaper from "./wallpaper.png";
import windowbg from "./windowbg.png";
import windowimg from "./window.png";

const preloadassets = [
  birds,
  book,
  bottomleft,
  bottomlefteyes,
  bottomright,
  bottomrighteyes,
  butterfly,
  candle,
  cloud,
  curtain,
  desk,
  emily,
  emilycollage,
  envelope,
  flowers,
  flowerscollage,
  greenbg,
  nophone,
  paper,
  quill,
  shelf,
  sticker,
  sun,
  topleft,
  toplefteyes,
  topright,
  toprighteyes,
  vine,
  volumeoff,
  volumeon,
  wallpaper,
  windowbg,
  windowimg
];

export default preloadassets;
